/**
 * Implements chain page placeholder
 */
import {
  AboutPlaceholder,
  PairsTablePlaceholder,
  SidebarPlaceholder,
} from '../../../components/SEO/Placeholder';

import '../../../components/SEO/styles.scss';

const ChainPagePlaceholder = () => {
  return (
    <div className='seo_page__content'>
      <div className='seo_page__about_token'>
        <div className='seo_page__main'>
          <AboutPlaceholder />
          <SidebarPlaceholder count={3} />
        </div>
      </div>
      <PairsTablePlaceholder fullWidth padding='8px 8px 4px' />
    </div>
  );
};

export default ChainPagePlaceholder;
